<template>
    <div class="verificationBox">
        <strong> 输入验证码 </strong>
        <p v-if="!isRegistered">该手机号未注册，输入验证码后将自动注册</p>
        <p v-else>
            验证码已发送至<span class="phone"> (+86) {{ userInfo.phone }}</span>
        </p>
        <div class="captcha vanCellGroup vanField">
            <input
                v-for="(c, index) in authCode"
                :key="index"
                type="number"
                v-model="authCode[index]"
                ref="input"
                :class="{ brdrClr: authCode[index] }"
                :style="{
                    borderBottomColor: index <= cIndex ? '#3760FF' : '',
                    borderBottomColor: Countdown <= 0 ? 'red' : ''
                }"
                @input="e => onInput(e, index)"
                @keydown.delete="e => onKeydown(e.target.value, index)"
                @focus="onFocus"
                :disabled="loading"
            />
        </div>
        <div class="rt">
            <van-button
                :disabled="!!Countdown"
                @click="postAccountGetAuthCode"
                round
                >重新获取 {{ Countdown ? `${Countdown}s` : "" }}</van-button
            >
        </div>
        <div class="ct">
            <img v-if="findBindInfo.logo" :src="findBindInfo.logo" alt="" />
            <p>{{ findBindInfo.branchName || "" }}</p>
        </div>
    </div>
</template>
<script>
export default {
    name: "verificationCode",
    data() {
        return {
            isRegistered: false,
            authCode: ["", "", "", "", "", ""],
            loading: false,
            msg: "",
            countdownInterval: null,
            Countdown: 60
        };
    },
    computed: {
        findBindInfo() {
            return this.$store.state.findBindInfo || {};
        },
        ctSize() {
            return this.authCode.length;
        },
        cIndex() {
            let i = this.authCode.findIndex(item => item === "");
            i = (i + this.ctSize) % this.ctSize;
            return i;
        },
        lastCode() {
            return this.authCode[this.ctSize - 1];
        },
        userInfo() {
            return this.$store.state.userInfo || {};
        }
    },
    created() {
        window.addEventListener("resize", this.inputFocus);
    },
    destroyed() {
        window.removeEventListener("resize", this.inputFocus);
    },
    mounted() {
        this.clientHeight = document.documentElement.clientHeight;
        this.resetCaret();
        this.postRegisterResult();

        if (!this.userInfo.phone) {
            this.$router.push({ name: "login" });
        }
        this.setCountdown();
    },
    directives: {
        focus: {
            componentUpdated: function(el, obj) {
                obj.value && el.focus();
            }
        }
    },
    methods: {
        inputFocus() {
            const height = document.documentElement.clientHeight;
            if (this.clientHeight > height) {
                let vanField = document.querySelectorAll(".vanField");
                let total = vanField[0].offsetTop - 20;
                document.body.scrollTop = total;
            } else {
                document.body.scrollTop = 0;
            }
            this.clientHeight = document.documentElement.clientHeight;
        },
        onInput(e, index) {
            this.msg = "";
            let val = e.target.value;
            val = val.replace(/\s/g, "");
            if (!/^\d+$/.test(val)) {
                this.authCode[index] = "";
                e.target.value = "";
            }
            if (index == this.ctSize - 1) {
                this.authCode[this.ctSize - 1] = val[0]; // 最后一个码，只允许输入一个字符。
            } else if (val.length > 1) {
                let i = index;
                for (
                    i = index;
                    i < this.ctSize && i - index < val.length;
                    i++
                ) {
                    this.authCode[i] = val[i];
                }
                this.resetCaret();
            }
        },
        // 重置光标位置。
        resetCaret() {
            this.$refs.input[this.ctSize - 1].focus();
        },
        onFocus() {
            let index = this.authCode.findIndex(item => item === "");
            index = (index + this.ctSize) % this.ctSize;
            this.$refs.input[index].focus();
        },
        onKeydown(val, index) {
            if (val === "") {
                if (index > 0) {
                    this.authCode[index - 1] = "";
                    this.$refs.input[index - 1].focus();
                }
            }
        },
        async postRegisterResult() {
            const data = { phone: this.userInfo.phone };
            return this.$api.usercenter
                .postRegisterResult({ data })
                .then(res => {
                    if (res.data) {
                        this.isRegistered = res.data;
                    }
                });
        },
        async postAccountLoginByAuthCode() {
            const data = {
                account: this.userInfo.phone,
                authCode: this.authCode.join("")
            };
            this.$store.state.distributionId &&
                (data.distributionId = this.$store.state.distributionId);
            await this.$api.usercenter
                .postAccountLoginByAuthCode({ data })
                .then(async res => {
                    if (res.code != 0) {
                        this.$notify(res.message);
                        return false;
                    }
                    if (res.data) {
                        localStorage.setItem("token", res.data);
                        this.getAccountUserInfo();
                        await localStorage.setItem(
                            "WDuserInfo",
                            JSON.stringify(this.$store.state.userInfo)
                        );
                        setTimeout(() => {
                            if (sessionStorage.getItem("realName")) {
                                location.replace("/idcard");
                            } else {
                                // location.reload(true)
                                if (this.$route.query.name) {
                                    location.replace(this.$route.query.name);
                                } else {
                                    location.reload(true);
                                }
                            }
                        }, 50);
                    } else {
                        this.authCode.map(() => "");
                        return res.data;
                    }
                })
                .catch(() => {
                    this.$toast("验证码有误，请检查一下吧");
                    this.authCode.map(() => "");
                    return false;
                });
        },
        async getAccountUserInfo(headers) {
            return this.$api.usercenter
                .getAccountUserInfo({ headers })
                .then(res => {
                    if (res.data) {
                        return res.data;
                    }
                })
                .catch(() => {
                    return null;
                });
        },
        postAccountGetAuthCode() {
            const data = { phone: this.userInfo.phone };
            clearInterval(this.countdownInterval);
            this.$sensors.track('UM_Click_Verification_Code_Button')
            this.$api.usercenter.postAccountGetAuthCode({ data }).then(res => {
                if (res.data) {
                    this.setCountdown();
                }
            });
        },
        setCountdown() {
            this.Countdown = 60;
            this.countdownInterval = setInterval(() => {
                this.Countdown--;
                if (this.Countdown <= 0) {
                    clearInterval(this.countdownInterval);
                }
            }, 1000);
        }
    },
    watch: {
        cIndex() {
            this.resetCaret();
        },
        lastCode(val) {
            if (val) {
                this.$refs.input[this.ctSize - 1].blur();
                this.postAccountLoginByAuthCode();
            }
        }
    }
};
</script>
<style lang="stylus" scoped>
.phone {
    color: #3660FF;
}

.ct {
    position: absolute;
    width: 100vw;
    text-align: center;
    bottom: 32px;
    left: 0px;

    img {
        width: 200px;
        margin-bottom: 16px;
    }

    p {
        color: #CCCCCC;
        font-size: 28px;
        margin-bottom: 28px;
    }
}

.verificationBox {
    padding: 50px;
    height: calc(100vh - 100px);
    min-height: 880px;
    background-color: #ffffff;
    position: relative;

    strong {
        margin-top: 120px;
        display: inline-block;
        font-size: 64px;
        font-weight: bold;
        color: #333333;
    }

    p {
        margin-top: 24px;
        font-size: 28px;
        color: #999999;
    }

    /deep/ .vanCellGroup {
        border-radius: 0;
        margin-top: 48px;
        // border-bottom: 1px #3760FF solid;
    }

    .Countdown {
        color: #3760FF;
        font-size: 24px;
        margin-top: 60px;
    }

    /deep/ .van-button {
        margin-top: 32px;
        line-height: 32px;
        height: 32px;
        padding: 0 17px;
        color: #ffff;
        background-color: #3760FF;
        border-color: #3760FF;

        .van-button__text {
            font-size: 14px;
        }
    }
}

.captcha {
    display: flex;
    justify-content: center;
    margin-top: 40px;
}

input {
    margin-right: 18px;
    width: 88px;
    text-align: center;
    border: none;
    border-bottom: 3px solid #A6A6A6;
    font-size: 64px;
    outline: none;
    border-radius: 0px;
}

input:last-of-type {
    margin-right: 0;
}

input:disabled {
    color: #000;
    background-color: #fff;
}

.msg {
    text-align: center;
}

input:focus {
    border-bottom: 3px solid #3760FF;
}

.brdrClr {
    border-color: #3760FF;
}
</style>
